export default "__VITE_ASSET__DhI7Du29__"